<template>
  <UserLanding>
    <div class="aboutusPage">
      <h2 class="title">Meet our team</h2>
      <div class="member"><img src="/1.jpeg" class="avatar">
        <div class="content">
          <h4 class="name">Jenna Mulji, Co-founder</h4>
          <p class="intro">As a public health student, Jenna is passionate about health from a holistic
            perspective and the integration of health with social justice. She has worked with various not for profit
            organizations in the past, all with the common goal of sharing the stories and voices of those often
            underrepresented in mainstream channels. Jenna hopes that, through Sunshine Connected, participants will have
            the opportunity to share their stories and build community with each other.</p>
        </div>
      </div>
      <div class="member"><img src="/2.jpeg" class="avatar">
        <div class="content">
          <h4 class="name">Aminah Beg, Co-founder</h4>
          <p class="intro">Aminah is a development student and practitioner, whose work greatly centers
            around the direct participation of marginalized communities in solutions for contemporary development issues,
            on domestic and international scales. Her past experience has seen Aminah working alongside various nonprofit
            organizations - tackling social, health, and environmental-based disparities - and she is currently a Research
            Assistant for a project surrounding the sustainable economic development of Indigenous communities in Canada.
            Aminah aspires for Sunshine Connected to be a platform that brings in the voices of younger generations to
            help fulfill the needs of older adults, a community whose value is often forgotten. </p>
        </div>
      </div>
      <div class="member"><img src="/4.jpeg" class="avatar">
        <div class="content">
          <h4 class="name">Samantha Gardner, Co-founder</h4>
          <p class="intro">Samantha is passionate about her community, health-tech, using technology to
            improve older adult care, and change management consulting. She is currently completing her Bachelor of
            Commerce at the University of Alberta, with a major in Human Resources and a minor in Business Technology
            Management. She loves working with others and is solution driven.</p>
        </div>
      </div>
      <div class="member"><img src="/5.jpeg" class="avatar">
        <div class="content">
          <h4 class="name">Tingzhou Jia, CTO</h4>
          <p class="intro">Tingzhou had over 4 years experience as software developer.</p>
        </div>
      </div>

      <div class="member"><img src="/3.png" class="avatar">
        <div class="content">
          <h4 class="name">Teressa Yu, Social Media and Marketing Lead</h4>
          <p class="intro">Teressa loves to problem solve and connect with people, leading her to 3
            years of leading small business companies with the Junior Achievement organization. Her entrepreneurial spirit
            loves learning, leading, and lifting others to achieve their best! She is currently pursuing a BComm degree at
            the University of Alberta</p>
        </div>
      </div>
      <div class="member">
        <router-link to="/join-us">
          <a-avatar :size="120" icon="plus" />
          <h4 style="text-align: center;" class="name">Join us</h4>
        </router-link>
      </div>
    </div>
  </UserLanding>
</template>

<script>
import UserLanding from "../components/userlanding.vue";
export default {
  components: {
    UserLanding,
  },
};
</script>

<style lang="less" scoped>
.aboutusPage {
  padding: 6.5rem 5rem;

  .title {
    font-style: normal;
    font-weight: 500;
    font-size: 30px;
    line-height: 40px;
    font-family: auto;
  }

  .member {
    display: flex;
    flex-direction: row;
    gap: 2rem;
    margin-bottom: 1.5rem;

    .avatar {
      width: 160px;
      height: 160px;
      border-radius: 8px;
    }

    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .name {
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        font-family: auto;
        color: #811113;
      }
    }
  }
}
</style>